import { render, staticRenderFns } from "./HotTopicList.vue?vue&type=template&id=235b5e6a"
import script from "./HotTopicList.vue?vue&type=script&lang=ts"
export * from "./HotTopicList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports